import { MapPin, Scale, Award, MessageSquare } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { SectionHeader } from "@/components/ui/SectionHeader";

const ProblemSolutionSection = () => {
  const { t } = useTranslation('home');

  // Altum's 4 Pillars
  const pillars = [
    {
      icon: MapPin,
      title: t('whyChoose.pillar1.title'),
      bullets: t('whyChoose.pillar1.bullets', { returnObjects: true }) as string[],
    },
    {
      icon: Scale,
      title: t('whyChoose.pillar2.title'),
      bullets: t('whyChoose.pillar2.bullets', { returnObjects: true }) as string[],
    },
    {
      icon: Award,
      title: t('whyChoose.pillar3.title'),
      bullets: t('whyChoose.pillar3.bullets', { returnObjects: true }) as string[],
    },
    {
      icon: MessageSquare,
      title: t('whyChoose.pillar4.title'),
      bullets: t('whyChoose.pillar4.bullets', { returnObjects: true }) as string[],
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-light-gray">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={t('whyChoose.eyebrow')}
          headline={t('whyChoose.headline')}
          subheadline={t('whyChoose.subheadline')}
          className="mb-16"
        />

        {/* Open columns: hairline above, red icon, title, bullets. No box. */}
        <div className="grid gap-x-12 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((pillar, index) => (
            <motion.div
              key={index}
              className="border-t border-border pt-6"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.8,
                delay: index * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
            >
              <pillar.icon className="h-8 w-8 text-primary" strokeWidth={2.5} aria-hidden="true" />
              <h3 className="mt-6 font-heading text-2xl uppercase leading-none text-navy">
                {pillar.title}
              </h3>
              <ul className="bullet-list mt-3">
                {pillar.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
